module.exports = __webpack_public_path__ + "static/img/11.967ab599.jpg";